function ShopMemberInfo(props) {
  return (
    <div className="col-12">
      <div className="row">
        <div className="col-12 mb-30">
          <h5 className="sub-title">업체정보</h5>
        </div>

        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">업체명</label>
            <input
              name="comname"
              type="text"
              className="form-control"
              maxLength="25"
              value={props.myinfo.comname || ""}
              readOnly={true}
            />
          </div>
        </div>

        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">대표자명</label>
            <input
              name="boss"
              type="text"
              className="form-control"
              maxLength="5"
              value={props.myinfo.boss || ""}
              readOnly={true}
            />
          </div>
        </div>

        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">사업자등록번호</label>
            <input
              name="comidno"
              type="text"
              className="form-control"
              maxLength="10"
              value={props.myinfo.comidno || ""}
              readOnly={true}
              data-type="int"
            />
          </div>
        </div>

        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">대표전화</label>
            <div className="input-group">
              <input
                name="tel0"
                type="text"
                className="form-control"
                maxLength="3"
                value={props.myinfo.tel0 || ""}
                readOnly={true}
                data-type="int"
              />
              <input
                name="tel1"
                type="text"
                className="form-control"
                maxLength="4"
                value={props.myinfo.tel1 || ""}
                readOnly={true}
                data-type="int"
              />
              <input
                name="tel2"
                type="text"
                className="form-control"
                maxLength="4"
                value={props.myinfo.tel2 || ""}
                readOnly={true}
                data-type="int"
              />
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">팩스</label>
            <div className="input-group">
              <input
                name="fax0"
                type="text"
                className="form-control"
                maxLength="4"
                value={props.myinfo.fax0 || ""}
                readOnly={true}
                data-type="int"
              />
              <input
                name="fax1"
                type="text"
                className="form-control"
                maxLength="4"
                value={props.myinfo.fax1 || ""}
                readOnly={true}
                data-type="int"
              />
              <input
                name="fax2"
                type="text"
                className="form-control"
                maxLength="4"
                value={props.myinfo.fax2 || ""}
                readOnly={true}
                data-type="int"
              />
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-4 col-sm-12"></div>
      </div>

      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">우편번호</label>
            <input
              name="zipcode"
              type="text"
              className="form-control"
              maxLength="5"
              value={props.myinfo.zipcode || ""}
              readOnly={true}
              data-type="int"
            />
          </div>
        </div>

        <div className="col-lg-8 col-md-8 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">주소</label>
            <input
              name="address1"
              type="text"
              className="form-control"
              max="50"
              value={props.myinfo.address1 || ""}
              readOnly={true}
              placeholder="우편번호 찾기 버튼을 이용해 주세요."
            />
          </div>
        </div>

        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="form-group">
            <label className="form-control-label">상세주소</label>
            <input
              id="address2"
              name="address2"
              type="text"
              className="form-control"
              max="50"
              value={props.myinfo.address2 || ""}
              readOnly={true}
              placeholder="나머지 주소를 입력하세요."
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShopMemberInfo;
